// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overview-module__ui-Overview--zfiqM {
  height: 473px;
  background: #090A0C;
  text-align: center;
  width: 100%;
}

.Overview-module__wrap--oP_FB {
  display: flex;
  align-items: stretch;
  gap: 40px;
  width: var(--layout-width);
  text-align: left;
  margin: 0 auto;
  box-sizing: border-box;
}

.Overview-module__ui-Overview-Content--pXGuk {
  display: flex;
  min-width: 0;
  padding-left: 70px;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
}

.Overview-module__ui-Overview-Content--pXGuk > p {
  margin: 0;
}

.Overview-module__leading--mMltS {
  position: relative;
  padding-left: 44px;
  color: #FF9800;
  font-size: 0.8125rem; /* 13px */
  font-weight: 400;
  line-height: 1.3636;
}

.Overview-module__leading--mMltS:after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  width: 32px;
  height: 1px;
  background: #FF9800;
  transform: translateY(-50%);
}

.Overview-module__title--c4DIU {
  padding-top: 16px;
  color: #ffffff;  
  font-size: 2.5rem; /* 40px */
  font-weight: 600;
  line-height: 1.2105;
  overflow-wrap: anywhere;

}

.Overview-module__content--Mf0D8 {
  padding-top: 18px;
  color: #9E9E9E;
  font-size: 1rem; /* 16px */
  font-weight: 500;
  line-height: 1.125;
  overflow-wrap: anywhere;
}

.Overview-module__description--zEHDx {
  padding-top: 17px;
  font-size: 0.875rem; /* 14px */
  color: #E0E0E0;
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.Overview-module__meta--Ql5ag {
  padding-top: 17px;
  font-size: 1.125rem; /* 18px */
  color: #E0E0E0;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.Overview-module__leading--mMltS + .Overview-module__title--c4DIU {
  padding-top: 8px;
}

.Overview-module__title--c4DIU + .Overview-module__content--Mf0D8 {
  padding-top: 12px;
}

.Overview-module__content--Mf0D8 + .Overview-module__description--zEHDx {
  padding-top: 5px;
}

.Overview-module__description--zEHDx + .Overview-module__meta--Ql5ag {
  padding-top: 20px;
}

.Overview-module__ui-Overview-Media--HtOZ2 {
  margin-top: 28px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  background-color: #111216;
  width: 650px;
  height: 408px;
}

.Overview-module__ui-Overview-Media--HtOZ2 > * {
  max-width: 100%;
}

.Overview-module__ui-Overview-Media--HtOZ2 .Overview-module__box--QyunB {
  position: relative;
  max-width: 100%;
  border: 20px solid #FCFAF7;
  box-shadow: 14px 14px 0 0 rgba(255, 152, 0, 0.33);
}
.Overview-module__ui-Overview-Media--HtOZ2 .Overview-module__box--QyunB:before {
  content: '';
  position: absolute;
  position: absolute;
}

.Overview-module__ui-Overview-Media--HtOZ2 :where(img) {
  display: block;
  max-width: 100%;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Overview/Overview.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,SAAS;EAC9B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,SAAS;EAC9B,cAAc;EACd,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd","sourcesContent":[".ui-Overview {\n  height: 473px;\n  background: #090A0C;\n  text-align: center;\n  width: 100%;\n}\n\n.wrap {\n  display: flex;\n  align-items: stretch;\n  gap: 40px;\n  width: var(--layout-width);\n  text-align: left;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.ui-Overview-Content {\n  display: flex;\n  min-width: 0;\n  padding-left: 70px;\n  flex: 1 1 auto;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.ui-Overview-Content > p {\n  margin: 0;\n}\n\n.leading {\n  position: relative;\n  padding-left: 44px;\n  color: #FF9800;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 400;\n  line-height: 1.3636;\n}\n\n.leading:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 32px;\n  height: 1px;\n  background: #FF9800;\n  transform: translateY(-50%);\n}\n\n.title {\n  padding-top: 16px;\n  color: #ffffff;  \n  font-size: 2.5rem; /* 40px */\n  font-weight: 600;\n  line-height: 1.2105;\n  overflow-wrap: anywhere;\n\n}\n\n.content {\n  padding-top: 18px;\n  color: #9E9E9E;\n  font-size: 1rem; /* 16px */\n  font-weight: 500;\n  line-height: 1.125;\n  overflow-wrap: anywhere;\n}\n\n.description {\n  padding-top: 17px;\n  font-size: 0.875rem; /* 14px */\n  color: #E0E0E0;\n  font-weight: 400;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.meta {\n  padding-top: 17px;\n  font-size: 1.125rem; /* 18px */\n  color: #E0E0E0;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.leading + .title {\n  padding-top: 8px;\n}\n\n.title + .content {\n  padding-top: 12px;\n}\n\n.content + .description {\n  padding-top: 5px;\n}\n\n.description + .meta {\n  padding-top: 20px;\n}\n\n.ui-Overview-Media {\n  margin-top: 28px;\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  background-color: #111216;\n  width: 650px;\n  height: 408px;\n}\n\n.ui-Overview-Media > * {\n  max-width: 100%;\n}\n\n.ui-Overview-Media .box {\n  position: relative;\n  max-width: 100%;\n  border: 20px solid #FCFAF7;\n  box-shadow: 14px 14px 0 0 rgba(255, 152, 0, 0.33);\n}\n.ui-Overview-Media .box:before {\n  content: '';\n  position: absolute;\n  position: absolute;\n}\n\n.ui-Overview-Media :where(img) {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Overview": `Overview-module__ui-Overview--zfiqM`,
	"wrap": `Overview-module__wrap--oP_FB`,
	"ui-Overview-Content": `Overview-module__ui-Overview-Content--pXGuk`,
	"leading": `Overview-module__leading--mMltS`,
	"title": `Overview-module__title--c4DIU`,
	"content": `Overview-module__content--Mf0D8`,
	"description": `Overview-module__description--zEHDx`,
	"meta": `Overview-module__meta--Ql5ag`,
	"ui-Overview-Media": `Overview-module__ui-Overview-Media--HtOZ2`,
	"box": `Overview-module__box--QyunB`
};
export default ___CSS_LOADER_EXPORT___;
